import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "columns" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = { class: "title is-4" }
const _hoisted_8 = { class: "subtitle is-6 has-text-grey" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "control" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "control" }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "control" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = {
  key: 0,
  class: "is-hidden-desktop my-4 card p-2"
}
const _hoisted_20 = { class: "px-3 py-3 is-size-5 has-text-weight-semibold" }
const _hoisted_21 = { class: "is-flex" }
const _hoisted_22 = { class: "is-flex-grow-1" }
const _hoisted_23 = { class: "image is-128x128" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "subtitle is-flex is-flex-direction-column is-justify-content-center" }
const _hoisted_26 = { class: "is-size-6 has-text-weight-semibold has-text-grey-dark" }
const _hoisted_27 = { class: "field" }
const _hoisted_28 = { class: "label" }
const _hoisted_29 = { class: "control" }
const _hoisted_30 = { class: "select is-fullwidth" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "field" }
const _hoisted_33 = { class: "label" }
const _hoisted_34 = { class: "control" }
const _hoisted_35 = { class: "has-text-centered" }
const _hoisted_36 = { class: "mt-4" }
const _hoisted_37 = {
  class: "hidden",
  action: "./api/payment/",
  method: "POST",
  id: "paymentForm"
}
const _hoisted_38 = { class: "column is-hidden-touch is-flex is-flex-direction-column" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: "https://i.imgur.com/8okmbCF.jpg",
  alt: "cat"
}, null, -1)
const _hoisted_40 = {
  key: 0,
  class: "card"
}
const _hoisted_41 = { class: "mt-6 px-3 py-3 is-size-4 has-text-weight-bold" }
const _hoisted_42 = { class: "is-flex is-align-items-center" }
const _hoisted_43 = { class: "image is-128x128" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "is-flex is-flex-direction-column" }
const _hoisted_46 = { class: "is-size-3 has-text-grey-dark" }
const _hoisted_47 = { class: "is-size-6 has-text-weight-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t('message.registrationTitle')), 1),
              _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.$t('message.registrationSubtitle')), 1),
              _createElementVNode("form", {
                class: "column is-flex is-flex-direction-column is-justify-content-center",
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.requestMeeting && _ctx.requestMeeting(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('message.veterinaryCenter')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "input",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.name,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('message.veterinarySurgeon')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "input",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.petName) = $event)),
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.petName,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('message.chiefComplaint')), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "textarea",
                      placeholder: _ctx.$t('message.describeChiefComplaint'),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
                      required: ""
                    }, null, 8, _hoisted_18), [
                      [
                        _vModelText,
                        _ctx.description,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                (_ctx.requested_user > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('message.imYourSpecialist')), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("figure", _hoisted_23, [
                            _createElementVNode("img", {
                              class: "is-rounded",
                              src: _ctx.specialistProfileImageURL,
                              alt: "no_profile_image"
                            }, null, 8, _hoisted_24)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.requestedUserData[0].name), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('message.vetSpecialists')), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requested_user) = $event)),
                        required: "",
                        class: "px-6"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsers, (user) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: user.user_id,
                            value: user.user_id
                          }, _toDisplayString(user.name), 9, _hoisted_31))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.requested_user]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('message.yourEmail')), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "input",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                      required: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.email,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: _normalizeClass(["button is-primary", {'is-loading':_ctx.isCreatingMeeting}])
                  }, _toDisplayString(_ctx.$t('message.requestConsultation')), 3),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_router_link, {
                      to: "/meeting",
                      class: "is-size-6"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('message.alreadyReceivedPIN')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ], 32),
              _createElementVNode("form", _hoisted_37, [
                _withDirectives(_createElementVNode("input", {
                  type: "hidden",
                  name: "payment_hash",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paymentHash) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.paymentHash]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              (_ctx.requested_user > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('message.imYourSpecialist')), 1),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("figure", _hoisted_43, [
                        _createElementVNode("img", {
                          class: "is-rounded",
                          src: _ctx.specialistProfileImageURL,
                          alt: "no_profile_image"
                        }, null, 8, _hoisted_44)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.requestedUserData[0].name), 1),
                        _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('message.letsSolveCaseTogether')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}